import moment, { Moment } from "moment-timezone";

// this will replace the timezone with UTC, but will maintain the local time
// ex: getLocalTimeInUTC(Moment obj of 7:00PM PT) will return (Moment obj of 7:00PM UTC)
export const getLocalTimeInUTC = (): Moment => moment().utc(true);
